import styled from 'styled-components';
import { Link } from 'react-router-dom';

import {
  colorAccent,
  colorBlack900,
  colorGrey400,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';

export const HeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${colorAccent};
  font-family: ${fontFamilyPrimary};
  font-size: 13px;
  line-height: 16px;
  padding-block: 4px;
  width: fit-content;

  &:hover {
    opacity: 0.8;
  }
`;

export const BackIcon = styled.span`
  display: inline-flex;
  transform: scaleX(-1);
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const SubTitle = styled.h1`
  margin: 0;
  font-family: ${fontFamilySecondary};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${colorGrey400};
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${colorBlack900};

  @media ${mediaQueryMobileLargeMin} {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const WrapperDatePicker = styled.div`
  & > div {
    height: 40px;
    width: 100%;
    margin: 0;
  }

  @media ${mediaQueryMobileLargeMin} {
    flex-shrink: 0;

    & > div {
      width: auto;
    }
  }
`;

export const RangeDatePickerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;

  & > div > div {
    height: 40px;
    width: 100%;
    margin: 0;
  }

  @media ${mediaQueryMobileLargeMin} {
    flex-shrink: 0;
    width: auto;

    & > div > div {
      width: auto;
    }
  }
`;

export const RangeDash = styled.div`
  flex-shrink: 0;
  width: 8px;
  height: 1px;
  background: ${colorBlack900};
`;
